module.exports = __webpack_public_path__ + "media/images/ln-img8-82fa6096259a36c6e96b6f85e5af3965.png";